export const BASE_URL = '/app/dashboard';
export const BASE_TITLE = ' SoWash NOVA App';

export const CONFIG = {
  layout: 'vertical'
};
